import Reports from '../../Lab Admin Tabs/Reports/Reports.jsx';

// Wrapper for Analyst Reports page, can pass props for Analyst-specific config if needed
const ReportsAnalystTable = (props) => {
  // If you need to override tabConfig or other props, do it here
  return <Reports {...props} showReNotifyButton={false} />;
};

export default ReportsAnalystTable;
